import { render, staticRenderFns } from "./product10.vue?vue&type=template&id=798752b0&scoped=true"
import script from "./product10.vue?vue&type=script&lang=js"
export * from "./product10.vue?vue&type=script&lang=js"
import style0 from "./product10.vue?vue&type=style&index=0&id=798752b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798752b0",
  null
  
)

export default component.exports